module.exports = __webpack_public_path__ + "static/005.thumb-f562c763f32d73dd0b24d34bb171ad55.jpg";